// extracted by mini-css-extract-plugin
export default {"App":"App_App__c7A-F","addBtn":"App_addBtn__oGxkU"};